export default {
  body: 'filson-soft, system-ui, sans-serif',
  heading: 'filson-soft, system-ui, sans-serif',
  mono: 'monospace',
};
